import { COLOR_FUNCTION } from '@/globalStyles';

export const StyleTextInput = `
width: 100%;

& .MuiOutlinedInput-root {
    width: 100%;
    display: flex;
    align-items: center;
    border-color: ${COLOR_FUNCTION.borderSecondary};
}
`;
